module.exports = __webpack_public_path__ + "img/logo.41e37239.png";